<template>
  <div>
    <el-form ref="form" :model="formData" :disabled="disabled" size="mini">
      <!-- :rules="rules" -->
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_salesPerson') || '业务开发'"
            prop="salesPersonCode"
          >
            <dict-select
              v-model="formData.salesPersonCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.salesPersonName"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_buyer') || '采购跟单'"
            prop="buyerCode"
          >
            <dict-select
              v-model="formData.buyerCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.buyerName"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_skuSalesChannel') || '产品类型'"
            prop="skuSalesChannel"
          >
            <dict-select
              v-model="formData.skuSalesChannel"
              url="/sys/common/dict/system"
              :body="{ dictType: 'skuSalesChannel' }"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              clearable
              filterable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_orderSource') || '订单来源'"
            prop="orderSource"
          >
            <dict-select
              v-model="formData.orderSource"
              url="/master/common/dict/biz"
              :body="{ dictType: 'orderSource' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_importanceLevel') || '重要程度'"
            prop="importanceLevel"
          >
            <dict-select
              v-model="formData.importanceLevel"
              url="/master/common/dict/biz"
              :body="{ dictType: 'importanceLevel' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_purchaseDate') || '下单日期'"
            prop="purchaseDate"
          >
            <el-date-picker
              v-model="formData.purchaseDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_quotedMethod') || '报价方式'"
            prop="quotedMethod"
          >
            <dict-select
              v-model="formData.quotedMethod"
              url="/sys/common/dict/system"
              :body="{ dictType: 'quotedMethod' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_totalQty') || '产品总数量'">
            <el-input v-model="formData.totalQty" clearable readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_totalAmount') || '采购金额'">
            <el-input v-model="formData.totalAmount" clearable readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_currencyUnit') || '货币单位'"
            prop="currencyUnit"
          >
            <dict-select
              v-model="formData.currencyUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'currencyUnit' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_deliveryDate') || '首次交货日期'"
            prop="deliveryDate"
          >
            <el-date-picker
              v-model="formData.deliveryDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('form_label_scm') || '执行工厂'"
            prop="scmCode"
          >
            <dict-select
              v-model="formData.scmCode"
              url="/master/common/dict/scmCooperated"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('form_label_factoryPaymentTerms') || '付款条件'"
            prop="factoryPaymentTerms"
          >
            <dict-select
              v-model="formData.factoryPaymentTerms"
              url="/master/common/dict/biz"
              :body="{ dictType: 'paymentTerms' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_orderScm') || '名义工厂'"
            prop="orderScmCode"
          >
            <dict-select
              v-model="formData.orderScmCode"
              url="/master/common/dict/scmCooperated"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_settlementFactory') || '结算工厂'"
            prop="settlementFactory"
          >
            <dict-select
              v-model="formData.settlementFactory"
              url="/master/common/dict/scmCooperated"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="
              $l('form_label_importanceLevelDesc') || '订单前期开发情况说明'
            "
          >
            <el-input
              v-model="formData.importanceLevelDesc"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              rows="4"
              maxlength="1000"
              show-word-limit
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$l('form_label_remark') || '订单备注'">
            <el-input
              v-model="formData.remark"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              rows="4"
              maxlength="1000"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
// import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    amzPurchaseChangeCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      formData: {
        salesPersonCode: '',
        salesPersonName: '',
        buyerCode: '',
        buyerName: '',
        purchaseDate: '',
        currencyUnit: '',
      },
      rules: {
        salesPersonCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        buyerCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        purchaseDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        orderSource: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        skuSalesChannel: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        deliveryDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        quotedMethod: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        importanceLevel: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        currencyUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        scmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        factoryPaymentTerms: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        orderScmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        settlementFactory: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    async getData() {
      const res = await this.$api
        .ecomAmzFtyPurchaseChangeDetailApi({
          amzPurchaseChangeCode: this.amzPurchaseChangeCode,
        })
        .catch(() => null)
      const data = res?.body || {}
      this.formData = { ...data }
      this.$emit('loaded', data)
    },
    async reload() {
      const res = await this.$api
        .ecomAmzFtyPurchaseChangeDetailApi({
          amzPurchaseChangeCode: this.amzPurchaseChangeCode,
        })
        .catch(() => null)
      const data = res?.body || {}
      const { totalQty, totalAmount } = data
      this.formData = { ...this.formData, totalQty, totalAmount }
    },
    // async save() {
    //   const result = await validate.formValidate([this.$refs.form])
    //   if (!result) return

    //   if (this.loadingOpen()) return
    //   const res = await this.$api
    //     .ecomAmzFtyPurchaseChangeApi(this.formData)
    //     .catch(() => null)
    //   this.loadingClose()
    //   if (!res) return
    //   const { status } = res
    //   if (status !== 200) {
    //     this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
    //     return
    //   }
    //   this.$message({
    //     showClose: true,
    //     message: this.$l('INDEX.tips_save_ok') || '保存成功！',
    //     type: 'success',
    //   })

    //   this.getData()
    // },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
.side-frame-danger {
  padding: 1px 5px;
  border-left: 3px solid $color-danger;
  height: 20px;
  margin-top: 3px;
}
</style>
